[
  { "id": "my-computer", "appId": "browser", "label": "My Computer", "icon": "computer", "col": 0, "row": 0, "payload": { "pageId": "ben" } },
  { "id": "projects", "appId": "projects", "label": "Projects", "icon": "folder", "col": 0, "row": 1 },
  { "id": "games", "appId": "games", "label": "Games", "icon": "games", "col": 0, "row": 2 },
  { "id": "wrack", "appId": "wrack", "label": "Wrack", "icon": "wrack", "col": 0, "row": 3 },
  { "id": "music", "appId": "music", "label": "Music", "icon": "music", "col": 0, "row": 4 },
  { "id": "videos", "appId": "videos", "label": "Videos", "icon": "videos", "col": 0, "row": 5 },
  { "id": "notepad", "appId": "notepad", "label": "Notepad", "icon": "notepad", "col": 1, "row": 0 },
  { "id": "about", "appId": "about", "label": "About", "icon": "about", "col": 1, "row": 1 },
  { "id": "recycle", "appId": "browser", "label": "Recycle Bin", "icon": "recycle", "col": 1, "row": 2, "payload": { "pageId": "recycle" } },
  { "id": "control", "appId": "control", "label": "Control Panel", "icon": "control", "col": 1, "row": 3 }
]
